import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import SuperFilter from './filters/SuperFilter';

function HeaderContent({ column, headerRef, onFilterChange, ...rest }) {
  return (
    <div
      className={`cell-${column.key}`}
      style={{ width: 'max-content', cursor: 'pointer' }}
    >
      <span
        className="filter-icon"
        style={{ marginRight: '0.3em' }}
        onClick={e => e.stopPropagation()}
      >
        {column && column.filterable && (
          <SuperFilter
            ref={headerRef}
            column={column}
            {...rest}
            onChange={onFilterChange}
          />
        )}
        {column.name}
      </span>
    </div>
  );
}

function ColumnPopover({ key, name, hint, ...rest }) {
  return (
    <Popover id={key}>
      <Popover.Title as="h3">{name}</Popover.Title>
      <Popover.Content>
        {hint}
      </Popover.Content>
    </Popover>
  )
}

function CustomHeaderFormatter(props) {
  const { column } = props;
  if (column.hint) {
    return (
      <OverlayTrigger
        trigger="hover"
        placement="top"
        overlay={p => <ColumnPopover {...column} {...p} />}
      >
        <HeaderContent {...props} />
      </OverlayTrigger>
    )
  }

  return <HeaderContent {...props} />;
}

CustomHeaderFormatter.propTypes = {
  headerRef: PropTypes.object.isRequired,
  column: PropTypes.object,
  onFilterChange: PropTypes.func.isRequired,
  getValidFilterValues: PropTypes.func.isRequired,
};

CustomHeaderFormatter.defaultProps = {
  column: { key: '' }
}

export default CustomHeaderFormatter;
